import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { setAuthToken } from "modules/auth/lib/setAuthToken"
import { BackofficeImpersonateOrganizationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Props = {
  onSuccess?: () => void
  shouldRedirect?: boolean
}

type Response = DataResponse<z.infer<typeof BackofficeImpersonateOrganizationResponseDataSchema>>

export function useImpersonateOrganizationMutation({
  onSuccess,
  shouldRedirect = true,
}: Props = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await axios.get<Response>(`/backoffice/organizations/impersonate/${id}`)
      return response.data.data
    },
    onSuccess: (data) => {
      setAuthToken({ queryClient, token: data.token })
      if (shouldRedirect) window.location.href = "/"
      onSuccess?.()
    },
  })
}
